import { useTranslation } from 'react-i18next';
import { useLang } from '@/hooks/useLang';

export default function FinalCtaSection() {
  const { t } = useTranslation();
  const lang = useLang();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
          {t('finalCta.h2')}
        </h2>
        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('finalCta.description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('finalCta.ctaPrimary')}
          </a>
          <a
            href={`/${lang}/allchinabuy-spreadsheet/`}
            className="inline-flex items-center justify-center px-6 py-3 border border-foreground-300 text-foreground-800 font-medium rounded-md hover:bg-background-200/70 transition-colors whitespace-nowrap"
          >
            {t('finalCta.ctaSecondary')}
          </a>
        </div>
      </div>
    </section>
  );
}